// extracted by mini-css-extract-plugin
export default {"webLink":"Footer_webLink__qH81j"};